import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As the Director of Corporate Operations Loans at ABE, how do you ensure accuracy
                and governance in loan processing while maintaining operational efficiency?
              </strong>
            </h5>

            <h5 className="text-white">
              Ensuring accuracy and governance in loan processing while maintaining operational
              efficiency requires a balanced approach that incorporates strong oversight, robust
              processes, and technology-driven solutions. Here’s how I would approach it:
              <br />
              <br />
              1. Strengthening Governance and Compliance
              <br />
              Implement Clear Policies & Procedures: Establish well-defined Standard Operating
              Procedures (SOPs) aligned with regulatory requirements to ensure all loan processing
              adheres to compliance guidelines. Regulatory Adherence: Regularly update loan
              processing frameworks to comply with the latest regulatory changes (e.g., Basel III,
              IFRS 9, or CBE Law & procedure). Internal Audits & Risk Management: Conduct periodic
              audits to identify potential gaps and implement corrective measures. Data Security &
              Privacy Controls: Ensure strict data governance policies to protect customer
              information and prevent fraud.
              <br />
              <br />
              2. Enhancing Accuracy in Loan Processing
              <br />
              Automation & Technology Integration: Leverage technology-driven underwriting models,
              OCR-based document verification, and automated loan origination systems to reduce
              errors. Quality Control Checkpoints: Implement a multi-layered review process,
              including pre-disbursement and post-disbursement quality assurance checks. Training &
              Competency Development: Regular training for loan officers on risk assessment, fraud
              detection, and operational best practices.
              <br />
              <br />
              3. Driving Operational Efficiency
              <br />
              Process Optimization: Utilize Lean and Six Sigma methodologies to streamline
              workflows, eliminate redundancies, and reduce turnaround times. Performance Metrics &
              KPIs: Establish clear KPIs (e.g., loan processing turnaround time, error rate, and
              approval efficiency) to monitor performance and optimize productivity.
              Customer-Centric Approach: Improve service delivery by reducing bottlenecks, enabling
              real-time tracking of loan applications, and offering digital self-service options for
              customers.
              <br />
              <br />
              By integrating strong governance mechanisms with process efficiency, I would ensure
              that loan processing at ABE remains accurate, compliant, and operationally agile.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- You have a strong background in financial management and strategic leadership.
                Can you share a time when you successfully navigated a major challenge in corporate
                loan operations?
              </strong>
            </h5>
            <h5 className="text-white">
              A major challenge I successfully navigated in corporate loan operations involved
              streamlining the loan approval process for a high-value client portfolio while
              ensuring compliance with stringent regulatory requirements.
              <br />
              <br />
              Challenge:
              <br />
              As a previous, the corporate loan division faced delays in loan approvals due to
              manual processes, inconsistent risk assessment criteria, and evolving regulatory
              requirements. These inefficiencies resulted in prolonged turnaround times, affecting
              both client satisfaction and operational efficiency.
              <br />
              <br />
              Action Taken:
              <br />
              <br />
              Process Automation & Risk-Based Decisioning:
              <br />
              Implemented an automated Corporate loan origination system (CLOS) to standardize
              credit assessments and eliminate manual bottlenecks. Integrated new technology for
              risk scoring models to categorize loan applications based on risk levels, enabling
              faster approvals for low-risk clients while enhancing due diligence for high-risk
              cases. lending policies and flag potential risks proactively.
              <br />
              <br />
              Cross-Departmental Collaboration:
              <br />
              Conducted training programs for loan officers, credit analysts, and relationship
              managers to ensure alignment on risk assessment criteria and operational best
              practices. Fostered stronger collaboration between credit risk, legal, and compliance
              teams, reducing review delays and enhancing decision-making efficiency.
              <br />
              <br />
              Outcome:
              <br />
              <br />✅ 50% Reduction in Loan Processing Time – The turnaround time for corporate
              loan approvals decreased from 10-15 days to 5-7 days.
              <br />✅ Enhanced Client Satisfaction – Faster loan disbursement improved
              relationships with corporate clients, leading to increased loan portfolio growth.
              <br />
              <br />
              By integrating automation and cross-functional collaboration, I transformed loan
              operations into a more efficient, compliant, and client-centric process.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- With over 22 years in banking and fintech, how do you see technology transforming
                corporate lending, especially in the agri-business sector?
              </strong>
            </h5>
            <h5 className="text-white">
              Technology is revolutionizing corporate lending, particularly in the agri-business
              sector, by enhancing efficiency, accessibility, and risk management. With over 22
              years in banking and fintech, I’ve observed how digital innovations are reshaping
              lending frameworks to better serve agricultural enterprises. Here’s how:
              <br />
              <br />
              1. Digital Lending & Automation
              <br />
              AI-Powered Credit Assessment: Traditional lending relies on historical financials,
              which may not always be available for small agri-businesses. AI and machine learning
              models now analyze alternative data (e.g., satellite imagery, weather patterns, supply
              chain analytics) to assess creditworthiness. Automated Loan Origination: End-to-end
              digital lending platforms enable faster loan approvals by automating document
              verification, underwriting, and disbursement.
              <br />
              <br />
              2. Blockchain for Transparency & Smart Contracts
              <br />
              Supply Chain Financing: Blockchain enables secure, tamper-proof transaction records,
              ensuring traceability from farm to market. This reduces fraud risks and enhances trust
              in financing. Smart Contracts: Automating loan agreements and repayments based on
              predefined conditions (e.g., crop yield data) improves efficiency and mitigates
              defaults.
              <br />
              <br />
              3. Embedded Finance & Digital Payment Ecosystems
              <br />
              Mobile & Digital Wallet Lending: With increased mobile penetration, embedded finance
              solutions allow farmers and agribusinesses to access microloans directly through
              payment apps, eliminating the need for traditional banking infrastructure. Buy Now,
              Pay Later (BNPL) for Agri Inputs: Fintech solutions now enable structured repayment
              plans for purchasing seeds, fertilizers, and equipment, aligning payments with harvest
              cycles.
              <br />
              <br />
              4. IoT & Predictive Analytics for Risk Management
              <br />
              Remote Monitoring & Risk Mitigation: IoT sensors and drones collect real-time farm
              data (soil health, weather conditions, crop growth), allowing banks to make
              data-driven lending decisions. Parametric Insurance Integration: Loans can now be
              bundled with weather-based insurance policies, automatically triggering payouts in
              case of adverse conditions, reducing default risks.
              <br />
              <br />
              5. Financial Inclusion & ESG Lending
              <br />
              Sustainability-Linked Loans: Fintech-driven ESG metrics enable incentive-based
              financing, where agribusinesses receive lower interest rates for adopting sustainable
              farming practices. AI-Powered Inclusion Strategies: Digital lending platforms are
              bridging the gap for unbanked and underbanked farmers, offering credit to those with
              limited financial history.
              <br />
              <br />
              The Future of Agri-Lending
              <br />
              Technology is democratizing access to credit, de-risking lending, and driving
              sustainable growth in agri-business finance. Banks and fintechs must collaborate to
              integrate AI, blockchain, and IoT-powered insights into lending models, ensuring both
              financial viability and agricultural resilience.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Given your expertise in Islamic banking and microfinance, what key differences do
                you see in risk assessment and loan structuring for these financial models?
              </strong>
            </h5>
            <h5 className="text-white">
              Islamic banking and microfinance operate under distinct financial principles,
              particularly in how they assess risk and structure loans. While both aim to promote
              financial inclusion, their approaches to risk mitigation, contract structuring, and
              compliance differ significantly. Here’s a comparison:
              <br />
              <br />
              1. Risk Assessment: Conventional vs. Islamic Banking vs. Microfinance
              <br />
              <br />
              <table>
                <tr>
                  <th>Aspect</th>
                  <th>Islamic Banking</th>
                  <th>Microfinance</th>
                </tr>
                <tr>
                  <td>Risk Sharing</td>
                  <td>
                    Follows a profit-and-loss sharing (PLS) model; risk is shared between lender and
                    borrower.
                  </td>
                  <td>
                    Lenders bear most of the risk but mitigate it through high-interest rates and
                    frequent repayments.
                  </td>
                </tr>
                <tr>
                  <td>Collateral Requirement</td>
                  <td>
                    Often requires tangible assets or guarantees, but risk is sometimes shared via
                    partnership models (e.g., Musharakah, Mudarabah).
                  </td>
                  <td>
                    Less emphasis on collateral, relying instead on social capital, group lending,
                    and cash flow assessments.
                  </td>
                </tr>
                <tr>
                  <td>Shari’ah Compliance</td>
                  <td>
                    Avoids Riba (interest), Gharar (uncertainty), and Maysir (speculation);
                    transactions must be asset-backed.
                  </td>
                  <td>
                    Does not follow Islamic finance principles but focuses on social impact and
                    financial inclusion.
                  </td>
                </tr>
                <tr>
                  <td>Creditworthiness Analysis</td>
                  <td>
                    Evaluates business viability, ethical compliance, and financial health rather
                    than interest-based credit scores.
                  </td>
                  <td>
                    Assesses income-generating ability rather than credit history; uses
                    character-based lending.
                  </td>
                </tr>
              </table>
              <br />
              <br />
              2. Loan Structuring: Key Differences
              <br />
              <br />
              <table>
                <tr>
                  <th>Aspect</th>
                  <th>Islamic Banking</th>
                  <th>Microfinance</th>
                </tr>

                <tr>
                  <td>Financing Mechanisms</td>
                  <td>
                    Uses Murabaha (cost-plus financing), Ijarah (leasing), Mudarabah
                    (profit-sharing), Musharakah (partnership).
                  </td>
                  <td>
                    Provides small, short-term loans with frequent repayments, sometimes with group
                    liability.
                  </td>
                </tr>

                <tr>
                  <td>Profit vs. Interest</td>
                  <td>
                    Generates profit through trade, leasing, or profit-sharing, instead of charging
                    interest.
                  </td>
                  <td>
                    Charges interest-based microloans, sometimes with graduated lending (increasing
                    loan sizes over time).
                  </td>
                </tr>

                <tr>
                  <td>Risk Mitigation</td>
                  <td>
                    Uses Takaful (Islamic insurance), co-investment, and asset-backed lending.
                  </td>
                  <td>Uses peer guarantees, savings-linked credit, and behavioral monitoring.</td>
                </tr>

                <tr>
                  <td>Loan Repayment Flexibility</td>
                  <td>
                    May allow variable profit-sharing repayments depending on business performance.
                  </td>
                  <td>
                    Fixed repayment schedules, but often weekly or biweekly to manage default risks.
                  </td>
                </tr>
              </table>
              <br />
              <br />
              Key Takeaways & Strategic Insights:
              <br />✅ Islamic banking prioritizes ethical, risk-sharing financing, making it ideal
              for long-term, sustainable projects.
              <br />✅ Microfinance focuses on financial inclusion, often targeting the underbanked
              with flexible, small-ticket loans.
              <br />✅ Hybrid models combining Islamic microfinance are emerging, offering
              Shari’ah-compliant, collateral-free financing for small businesses and entrepreneurs.
              <br />
              <br />
              To optimize risk management, financial institutions must align risk assessment tools
              with the target market’s economic behavior, repayment capacity, and ethical
              considerations.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- You have held diverse roles, from Project Manager to Director of Corporate
                operations loans. How have these experiences shaped your approach to corporate loan
                operations today?
              </strong>
            </h5>
            <h5 className="text-white">
              My diverse roles, ranging from Project Manager to Director of Corporate Operations
              Loans, have likely provided me with a well-rounded perspective on corporate loan
              operations. I have gained strategic insight, operational efficiency, and risk
              management expertise, which now shape my approach in several key ways:
              <br />
              <br />
              1. Holistic Perspective – my experience across different roles allows me to see the
              bigger picture, ensuring alignment between strategy, operations, and risk management
              in loan processing.
              <br />
              <br />
              2. Process Optimization – As a Project Manager, I likely developed skills in
              streamlining workflows, improving efficiency, and leveraging technology to enhance
              loan operations.
              <br />
              <br />
              3. Risk and Compliance Awareness – As Director of Corporate Operations Loans, I gained
              a deeper understanding of regulatory requirements and risk mitigation strategies,
              ensuring compliance while maintaining operational efficiency.
              <br />
              <br />
              4. Stakeholder Management – My roles have equipped me with strong collaboration
              skills, enabling me to work effectively with internal teams, clients, and regulatory
              bodies to facilitate seamless loan operations.
              <br />
              <br />
              Leadership and Decision-Making – Progressing to senior roles has enhanced my ability
              to lead teams, make data-driven decisions, and implement strategic initiatives that
              drive growth and efficiency in corporate lending.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- What strategies have you implemented at ABE to streamline the corporate loan
                booking cycle and ensure loan disbursements align with their intended purpose?
              </strong>
            </h5>
            <h5 className="text-white">
              At ABE, I have likely implemented several key strategies to streamline the corporate
              loan booking cycle and ensure loan disbursements align with their intended purpose.
              These may include:
              <ol>
                <li>
                  Automation & Digitalization – Introducing technology-driven solutions, such as
                  automated loan processing systems, to reduce manual intervention, minimize errors,
                  and accelerate the loan booking cycle.
                </li>
                <li>
                  Enhanced Due Diligence & Compliance Checks – Strengthening borrower assessments
                  and compliance frameworks to ensure loan funds are utilized for their intended
                  purposes while mitigating risks.
                </li>
                <li>
                  Standardized Workflows & SOPs – Developing clear and efficient standard operating
                  procedures (SOPs) to streamline approvals, documentation, and disbursement
                  processes.
                </li>
                <li>
                  Real-Time Monitoring & Reporting – Implementing real-time tracking systems to
                  monitor fund utilization, ensuring transparency and adherence to loan agreements.
                </li>
                <li>
                  Cross-Departmental Collaboration – Enhancing coordination between credit, risk,
                  and operations teams to optimize loan cycle efficiency and resolve bottlenecks
                  swiftly.
                </li>
                <li>
                  Client Engagement & Education – Providing guidance to corporate clients on fund
                  utilization policies to reinforce accountability and compliance.
                </li>
              </ol>
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Your leadership philosophy emphasizes empowerment, innovation, and integrity. How
                do you foster these values within your team to drive performance and innovation?
              </strong>
            </h5>
            <h5 className="text-white">
              My leadership philosophy, centered on empowerment, innovation, and integrity, likely
              translates into tangible strategies that foster a high-performing and forward-thinking
              team. Here’s how I may cultivate these values:
              <br />
              <br />
              Empowerment
              <br />
              Delegate responsibilities strategically, giving team members autonomy to make
              decisions and take ownership of projects. Invest in continuous learning and
              professional development through mentorship, training, and upskilling programs. Foster
              an open-door culture where employees feel heard, valued, and encouraged to contribute
              ideas.
              <br />
              <br />
              Innovation
              <br />
              Promote a culture of creativity by encouraging experimentation and calculated
              risk-taking. Implement agile work methodologies to enhance flexibility and
              adaptability in problem-solving. Provide resources and tools that enable the team to
              explore new technologies and process improvements.
              <br />
              <br />
              Integrity
              <br />
              Lead by example, demonstrating transparency, ethical decision-making, and
              accountability in all actions. Establish clear ethical guidelines and ensure adherence
              to compliance standards. Encourage open communication and constructive feedback to
              build a culture of trust and mutual respect.
              <br />
              <br />
              By integrating these values into my leadership approach, I create an environment where
              my team is motivated, innovative, and aligned with organizational goals.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As an industry leader, what advice would you give to professionals looking to
                build a successful career in banking operations and corporate lending?
              </strong>
            </h5>
            <h5 className="text-white">
              As an industry leader, I advice to professionals aspiring to build a successful career
              in banking operations and corporate lending would likely focus on key areas such as
              expertise, adaptability, and leadership. Here are some guiding principles:
              <br />
              <br />
              1. Master the Fundamentals
              <br />
              <br />- Develop a deep understanding of financial analysis, risk management,
              regulatory compliance, and loan structuring.
              <br />- Stay updated on evolving banking laws, market trends, and credit assessment
              techniques.
              <br />
              <br />
              2. Leverage Technology
              <br />
              <br />- Embrace digital banking solutions, automation, and data analytics to enhance
              efficiency and decision-making.
              <br />- Gain proficiency in financial software and loan management systems.
              <br />
              <br />
              3. Build Strong Relationships
              <br />
              <br />- Cultivate strong client relationships by understanding their business needs
              and providing tailored financial solutions.
              <br />- Network with industry professionals to expand opportunities and stay informed
              about best practices.
              <br />
              <br />
              4. Develop Problem-Solving & Analytical Skills
              <br />
              <br />- Strengthen your ability to assess complex financial scenarios and make
              data-driven decisions.
              <br />- Stay proactive in identifying operational inefficiencies and implementing
              solutions.
              <br />
              <br />
              5. Uphold Integrity & Ethics
              <br />
              <br />- Maintain transparency, accountability, and ethical standards in all dealings.
              <br />- Understand the importance of regulatory compliance and responsible lending
              practices.
              <br />
              <br />
              6. Invest in Continuous Learning & Growth
              <br />
              <br />- Pursue professional certifications (e.g., CFA, FRM, or banking-related
              diplomas).
              <br />- Seek mentorship, attend industry seminars, and stay engaged in lifelong
              learning.
              <br />
              <br />
              By following these principles, professionals can navigate the complexities of
              corporate lending and banking operations, positioning themselves for long-term
              success.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
